module.exports = __webpack_public_path__ + "img/mistakesText1.bce6251a.png";